import axios from "axios";

import config from "../config/config";
import { getToken } from "../common";

export const toggleAPIKeyStatusAPI = async ({ name, isActive }) => {
  return await axios({
    method: "put",
    url: `${config.api.base_url}api-keys/${name}`,
    data: { isActive },
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default toggleAPIKeyStatusAPI;
